import { useEffect, useMemo, useState } from "react";
import { isAfter, isBefore } from "date-fns";

import styles from "./TimeSlots.module.css";

const useCurrentTime = () => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(interval);
  }, []);
  return now;
};

export const TimeSlots = ({ timeSlots, slotDurationMinutes, showTimeIndicator, indicatorWidth }) => {
  const now = useCurrentTime();

  const indicatorTop = useMemo(() => {
    if (!showTimeIndicator || !timeSlots?.length) return null;
    const slotIndex = timeSlots.findIndex((slot) => slot.start <= now && slot.end > now);
    if (slotIndex === -1) return null;
    const slotHeight = slotDurationMinutes === 5 ? 45 : 60;
    const rowHeight = slotHeight + 12;
    const progress =
      (now - timeSlots[slotIndex].start) /
      (timeSlots[slotIndex].end - timeSlots[slotIndex].start);
    return slotIndex * rowHeight + progress * slotHeight;
  }, [showTimeIndicator, timeSlots, slotDurationMinutes, now]);

  return (
    <div className={styles.timebar}>
      {indicatorTop !== null && (
        <>
          <div className={styles.indicatorLine} style={{ top: indicatorTop, width: indicatorWidth || "100%" }} />
          <div className={styles.indicatorDot} style={{ top: indicatorTop - 5 }} />
        </>
      )}
      {timeSlots.map((time, index) => {
        const isInPast = isBefore(time.start, new Date());
        const isInFuture = isAfter(time.end, new Date());

        let timeClass = styles.currentTime;

        if (isInFuture) {
          timeClass = styles.futureTime;
        }

        if (isInPast) {
          timeClass = styles.pastTime;
        }

        return (
          <div
            className={`${styles.time} ${timeClass}`}
            key={index}
            style={{
              height: slotDurationMinutes === 5 ? "45px" : "60px",
            }}
          >
            <span className={styles.timeLabel}>{time.formattedRange}</span>
          </div>
        );
      })}
    </div>
  );
};
